const MODULES = {
  PRIVACY_BY_DESIGN: 'privacy_by_design',
  AI_INVENTORY: 'ai_inventory',
  COMPANY_SUPPLIER: 'company_supplier',
}

export default { MODULES }
